export default __webpack_public_path__ + "static/media/pic3.1ea65d13.png";